<template>
  <PopupBox :title="$t('new_object', { object: $t('models.location') })">
    <template v-slot:control>
      <button class="btn btn-sm" @click="onCloseNewLocationPopup">
        <show-icon name="close" size="sm"></show-icon>
      </button>
    </template>
    <div style="height: 50oem" class="row overflow-auto text-start">

      <form @submit.prevent="onQuickAddLocation" method="POST" ref="location_form" id="location_form" novalidate>

        <div class="row mb-3">
          <div class="col-12">
            <label for="building_uuid" class="float-left">{{ $t("attributes.location.building_name") }}</label>
            <div class="input-group">
              <select name="building_uuid" ref="building_uuid" class="form-select" @input="onUpdateBuilding">
                <option></option>
                <option v-for="building in allBuildings" :key="building.uuid" :value="building.uuid">
                  {{ building.name }}
                </option>
                <option value="new_building">
                  + {{ $t('new') }}
                </option>        
              </select>
              <input type="text" :value="location.building_name" class="form-control" name="building_name" ref="building_name" @input="onUpdateFormParam" v-show="showNewBuilding">
            </div>
          </div>

          <div class="col-12">
            <label for="area_uuid" class="float-left">{{ $t("attributes.location.area_name") }}</label>
            <div class="input-group">
              <select name="area_uuid" ref="area_uuid" class="form-select" @input="onUpdateArea">
                <option></option>
                <option v-for="area in allAreas()" :key="area.uuid" :value="area.uuid">
                  {{ area.name }}
                </option>
                <option value="new_area">
                  + {{ $t('new') }}
                </option>        
              </select>
              <input type="text" :value="location.area_name" class="form-control" name="area_name" ref="area_name" @input="onUpdateFormParam" v-show="showNewArea">
            </div>
          </div>

          <div class="col-12">
            <label for="level_uuid" class="float-left">{{ $t("attributes.location.level_name") }}</label>
            <div class="input-group">
              <select name="level_uuid" ref="level_uuid" class="form-select" @input="onUpdateLevel">
                <option></option>
                <option v-for="level in allLevels()" :key="level.uuid" :value="level.uuid">
                  {{ $t('models.level') }} {{ level.name }}
                </option>
                <option value="new_level">
                  + {{ $t('new') }}
                </option>        
              </select>              
              <input type="text" :value="location.level_name" class="form-control" name="level_name" ref="level_name" @input="onUpdateFormParam" v-show="showNewLevel">
            </div>
          </div>

          <div class="col-12">
            <label for="location_uuid" class="float-left">{{ $t("attributes.location.location_name") }}</label>
            <div class="input-group">
              <select name="location_uuid" ref="location_uuid" class="form-select" @input="onUpdateLocation">
                <option></option>
                <option v-for="location in allLocations()" :key="location.uuid" :value="location.uuid">
                  {{ location.name }}
                </option>
                <option value="new_location">
                  + {{ $t('new') }}
                </option>        
              </select>                
              <input type="text" :value="location.location_name" class="form-control" name="location_name" ref="location_name" @input="onUpdateFormParam" v-show="showNewLocation">
            </div>
          </div>
        </div>

        <div class="row mb-3 justify-content-left">
          <div class="col-6">
            <button class="btn btn-primary btn-lg btn-block float-start" type="submit" id="submit">{{ $t("submit" )}}</button>
          </div>
        </div>      

      </form>

    </div>
  </PopupBox>
</template>

<script>
//import { useStore } from 'vuex';
import { setFieldValidity } from '@/common/form_field_validation';
import PopupBox from '@/components/PopupBox.vue'

export default {
  name: "NewLocationPopup",
  setup() {
    const location_types = [
      "Building",
      "Area",
      "Level",
      "Location"
    ];
    return {
      location_types
    }    
  },
  props: [
    "siteId",
    "assetId"
  ],
  emits: [
    "closeNewLocationPopup",
    "locationUpdated"
  ],  
  data() {
    return {
      location: {
        uuid: null,
        site_uuid: this.siteId,
        building_name: null,
        building_uuid: null,
        level_name: null,
        level_uuid: null,
        area_name: null,
        area_uuid: null,
        location_name: null,
        location_uuid: null,
        name: null,
        description: null
      },
      showNewBuilding: false,
      showNewArea: false,
      showNewLevel: false,
      showNewLocation: false
    }
  },
  computed: {
    allBuildings() {
      return this.$store.getters.getLocationsBySiteUUID(this.siteId).filter(function(loc) {
        return (loc.type === "Building");
      })
    }
  },
  methods: {

    allAreas() {
      const allSiteAreas =  this.$store.getters.getLocationsBySiteUUID(this.siteId).filter(function(loc) {
        return (loc.type === "Area");
      })        
      if (this.location.building_uuid) {
        return allSiteAreas.filter(area => area.owner_uuid === this.location.building_uuid);
      } else {
        return allSiteAreas;
      }
    },

    allLevels() {
      const allSiteLevels =  this.$store.getters.getLocationsBySiteUUID(this.siteId).filter(function(loc) {
        return (loc.type === "Level");
      })        
      console.log("Inside locations/NewLocationPopup.vue, allLevels(), allSiteLevels ==> ", allSiteLevels)
      console.log("Inside locations/NewLocationPopup.vue, allLevels(), this.location.building_uuid ==> ", this.location.building_uuid)
      if (this.location.area_uuid) {
        return allSiteLevels.filter(level => level.owner_uuid === this.location.area_uuid);
      } else if (this.location.building_uuid) {
        return allSiteLevels.filter(level => level.owner_uuid === this.location.building_uuid);
      } else {
        return allSiteLevels;
      }      
    },

    allLocations() {
      const allSiteLocations =  this.$store.getters.getLocationsBySiteUUID(this.siteId).filter(function(loc) {
        return (loc.type === "Location");
      })        
      if (this.location.area_uuid) {
        return allSiteLocations.filter(level => level.owner_uuid === this.location.area_uuid);
      } else if (this.location.level_uuid) {
        return allSiteLocations.filter(level => level.owner_uuid === this.location.level_uuid);
      } else if (this.location.building_uuid) {
        return allSiteLocations.filter(level => level.owner_uuid === this.location.building_uuid);
      } else {
        return allSiteLocations;
      }      
    },

    onUpdateFormParam(e) {
      const fieldName = e.target.name;
      this.location[fieldName] = e.target.value;
      setFieldValidity(this.$refs, fieldName, null);
    },    

    onCloseNewLocationPopup() {
      this.$emit("closeNewLocationPopup");
    },

    async onQuickAddLocation() {
      const locationUUID = await this.$store.dispatch("quickAddLocation", this.location);
      this.$emit("locationUpdated", locationUUID);
    },

    onUpdateBuilding(e) {
      const selected = e.target.value;
      if (selected === "new_building") {
        this.addingNewBuilding();
      } else {
        this.location.building_uuid = selected;
        this.location.building_name = null;
        this.location.area_uuid = null;
        this.location.level_uuid = null;
        this.location.location_uuid = null;
        this.showNewBuilding = false
      }
    },

    onUpdateArea(e) {
      const selected = e.target.value;
      if (selected === "new_area") {
        this.addingNewArea();
      } else {
        this.location.area_uuid = selected;
        this.location.area_name = null;
        this.location.level_uuid = null;
        this.location.location_uuid = null;
        this.showNewArea = false
      }
    }, 

    onUpdateLevel(e) {
      const selected = e.target.value;
      if (selected === "new_level") {
        this.addingNewLevel();
      } else {
        this.location.level_uuid = selected;
        this.location.level_name = null;
        this.location.location_uuid = null;
        this.showNewLevel = false
      }
    },

    onUpdateLocation(e) {
      const selected = e.target.value;
      if (selected === "new_location") {
        this.addingNewLocation();
      } else {
        this.location.location_uuid = selected;
        this.location.location_name = null;
        this.showNewLocation = false
      }
    },
    
    addingNewBuilding() {
      this.location.building_uuid = null;
      this.showNewBuilding = true;
      this.addingNewArea();
    },

    addingNewArea() {
      this.$refs.area_uuid.value = "new_area"
      this.location.area_uuid = null;
      this.showNewArea = true;
      this.addingNewLevel();
    },

    addingNewLevel() {
      this.$refs.level_uuid.value = "new_level"
      this.location.level_uuid = null;
      this.showNewLevel = true;
      this.addingNewLocation();
    },   
    
    addingNewLocation() {
      this.$refs.location_uuid.value = "new_location"
      this.location.location_uuid = null;
      this.showNewLocation = true;
    }    
  },
  components: {
    PopupBox
  }  
}
</script>